<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required, Hint } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	const mustBeInteger = (x) => {
		if (isNaN(Number(x)) || Number(x) <= 0 || Number(x) > 99) {
			console.log("not a valid number");
			return { mustBeInteger: true };
		}
	};

	let fields = [
		{
			labelName: "age",
			label: "What is your age?",
			options: [
				{
					// type: "Number",
					value: "", // value/response to send to server
					option: "", // what to display
					validate: [required, mustBeInteger],
				},
			],
			hintText: "Enter a valid number",
		},
		{
			labelName: "gender",
			label: "What is your gender?",
			options: [
				{
					type: "radio",
					value: "female",
					option: "Female",
					validate: [required],
				},
				{
					type: "radio",
					value: "male",
					option: "Male",
					validate: [required],
				},
				{
					type: "radio",
					value: "trans-female",
					option: "Transgender-female",
					validate: [required],
				},
				{
					type: "radio",
					value: "trans-male",
					option: "Transgender male",
					validate: [required],
				},
				{
					type: "radio",
					value: "trans-non-binary",
					option: "Transgender/non-binary",
					validate: [required],
				},
				{
					type: "radio",
					value: "other",
					option: "Other",
					validate: [required],
				},
			],
		},
		{
			labelName: "ethnicity",
			label: "Which ethnicity do you identify most with? You may choose more than one option.",
			options: [
				{
					type: "checkbox",
					value: "white-caucasian",
					option: "White or Caucasian",
					validate: [],
				},
				{
					type: "checkbox",
					value: "black-african-american",
					option: "Black or African American",
					validate: [],
				},
				{
					type: "checkbox",
					value: "asian",
					option: "Asian",
					validate: [],
				},
				{
					type: "checkbox",
					value: "american-indian-alaska-native",
					option: "American Indian or Alaska Native",
					validate: [],
				},
				{
					type: "checkbox",
					value: "native-hawaiian-pacific-islander",
					option: "Native Hawaiian or Pacific Islander",
					validate: [],
				},
				{
					type: "checkbox",
					value: "other",
					option: "Other",
					validate: [],
				},
				{
					type: "checkbox",
					value: "prefer-not-to-say",
					option: "Prefer not to say",
					validate: [],
				},
			],
		},
		{
			labelName: "attentioncheck2",
			label: "People are very busy these days and many do not have time to follow what goes on in the government. We are testing whether people read questions. To show that you've read this much, answer both 'extremely interested' and 'very interested'",
			options: [
				{
					type: "checkbox",
					value: "not-at-all-interested",
					option: "Not at all interested",
					validate: [],
				},
				{
					type: "checkbox",
					value: "slightly-interested",
					option: "Slightly interested",
					validate: [],
				},
				{
					type: "checkbox",
					value: "moderately-interested",
					option: "Moderately interested",
					validate: [],
				},
				{
					type: "checkbox",
					value: "very-interested",
					option: "Very interested",
					validate: [],
				},
				{
					type: "checkbox",
					value: "extremely-interested",
					option: "Extremely interested",
					validate: [],
				},
			],
		},
		{
			labelName: "covidvaccine",
			label: "How do you feel about the COVID-19 vaccine?",
			options: [
				{
					type: "radio",
					value: "1_definitely-not-get-it",
					option: "Definitely not getting it",
					validate: [required],
				},
				{
					type: "radio",
					value: "2_probably-not-get-it",
					option: "Probably won't get it",
					validate: [required],
				},
				{
					type: "radio",
					value: "3_unsure",
					option: "Unsure",
					validate: [required],
				},
				{
					type: "radio",
					value: "4_probably-get-it",
					option: "Probably getting it",
					validate: [required],
				},
				{
					type: "radio",
					value: "5_definitely-get-it",
					option: "Definitely getting it",
					validate: [required],
				},
				{
					type: "radio",
					value: "6_vaccinated",
					option: "I have already been vaccinated",
					validate: [required],
				},
			],
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Demographics</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={option.validate}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
				{#if field.labelName === "age"}
					<Hint for={field.labelName} on="mustBeInteger">
						<span style="color:red">{field.hintText}</span>
					</Hint>
				{/if}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}
	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
